export const normalizeUnit = (value: string) =>
  ({
    bundles: "BD",
    bundle: "BD",
    squares: "SQ",
    square: "SQ",
    rolls: "RL",
    roll: "RL",
    each: "EA",
    pieces: "PC",
    pcs: "PC",
    piece: "PC",
    ft: "LF",
    sqft: "SF",
    "sq ft": "SF",
  })[value.toLowerCase()] || value.toUpperCase();
export const unitLabel = (value: string) =>
  ({
    BD: "bundles",
    SQ: "squares",
    RL: "rolls",
    EA: "each",
    PC: "pieces",
    LF: "linear feet",
    SF: "square feet",
  })[normalizeUnit(value)] || value;

/** Exact decimal ceiling: avoids floating point adding an extra ordering unit. */
export function orderQuantity(
  quantity: string,
  factor: string,
  coverage = "1",
): number | null {
  function decimal(value: string) {
    if (!/^\d+(\.\d+)?$/.test(value) || value.length > 30) return null;
    const [whole, fraction = ""] = value.split(".");
    const numerator = BigInt(whole + fraction);
    return numerator > 0n ? [numerator, 10n ** BigInt(fraction.length)] : null;
  }
  const q = decimal(quantity),
    f = decimal(factor),
    c = decimal(coverage);
  if (!q || !f || !c) return null;
  const numerator = q[0] * f[0] * c[1];
  const denominator = q[1] * f[1] * c[0];
  const result = (numerator + denominator - 1n) / denominator;
  return result <= 99999999n ? Number(result) : null;
}

export const needsSameUnitReset = (
  takeoffUnit: string,
  orderingUnit: string,
  factor: string,
  coverage = "1",
) =>
  normalizeUnit(takeoffUnit) === normalizeUnit(orderingUnit) &&
  Number(factor) !== Number(coverage);
